import React from 'react';
import './message-preview.css';
import classNames from 'classnames';
import { Paragraph } from '../../../../components/paragraph';
import { Icon } from '../../../../components/icon';
import { IconButton } from '../../../../components/icon-button';

const MessagePreview = props => {
    const { sender, senderType, subject, onClick, modalVisible } = props;

    const senderImageClasses = classNames({
        'message-preview__sender': true,
        'message-preview__sender--media': senderType === 'Media',
        'message-preview__sender--whip':
            senderType === 'Whip' || senderType === 'Staff member',
        'message-preview__sender--business': senderType === 'Business',
        'message-preview__sender--public':
            senderType === 'Group' || senderType === 'campaign',
    });

    return (
        <div className="message-preview">
            <div className={senderImageClasses}>
                <Icon iconName="sender" size="x-small" altText="" />
            </div>
            <div className="message-preview__text">
                <Paragraph
                    colorScheme="light"
                    withSpacing={false}
                    withIndent={true}
                >
                    {sender}
                </Paragraph>
                <Paragraph
                    colorScheme="light"
                    withSpacing={false}
                    withIndent={true}
                >
                    {subject}
                </Paragraph>
            </div>
            <IconButton
                onClick={onClick}
                iconName="arrow"
                size="small"
                type="main"
                isDisabled={modalVisible}
                altText="choose message"
            />
        </div>
    );
};

export { MessagePreview };
